
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.819 18.857h5.09v.014c0 1.176-1.14 2.129-2.545 2.129-1.406 0-2.546-.953-2.546-2.129v-.014zm9.988-3.123c.232.332.257.762.064 1.117s-.57.578-.983.578H4.112c-.412 0-.79-.223-.983-.578a1.062 1.062 0 01.064-1.117l2.2-3.153V8.647c0-2.653 1.938-4.865 4.508-5.363V2.072C9.9 1.48 10.393 1 11 1s1.1.48 1.1 1.072v1.212c2.57.498 4.507 2.71 4.507 5.363v3.934l2.2 3.153z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_bell.svg